export enum ELanguage {
	russian,
	azerbaijani
}